import React, { Component } from 'react';
import { ImageWithMarker} from './ImageWithMarker';

const queryString = require('query-string');

export class Large extends Component {
  displayName = Large.name

  render() {
    const parsed = queryString.parse(this.props.location.search);
    const roomName = parsed.roomName; 
    const mapTitle = parsed.mapTitle; 
    const roomImage = parsed.roomImage; 
    const x = parsed.x; 
    const y = parsed.y; 

    return (
      <div>
        <div className="ms-font-xxl ms-fontWeight-semibold">{mapTitle}: {roomName}</div>
        <ImageWithMarker url={roomImage} markerX={x} markerY={y}/>
      </div>
    );
  }
}
